import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Dimensions
} from 'react-native';
import styles from '../../style/popupmodel';
import alertPrompt from "../../style/popupmodel"
import { LinearGradient } from 'expo-linear-gradient';

export default function PopUpModel(props) {
  const [windowWidth, setWindowWidth] = useState(null);
  useEffect(() => {
    setWindowWidth(Dimensions.get('window').width);
  }, []);

  const notificationTestId = props.errorTestId ? `${props.errorTestId}-notification` : 'notification';
  const messageTestId = props.errorTestId ? `${props.errorTestId}-message` : 'message';
  const closeButtonTestId = props.errorTestId ? `${props.errorTestId}-closeButton` : 'closeButton';
  const cancelIconTestId = props.errorTestId ? `${props.errorTestId}-cancelIcon` : 'cancelIcon';

  //  console.log("real window",windowWidth)
  return (
    <>
      <View style={[windowWidth >= 900 ? styles.alertContainer : alertPrompt.alerBoxPopup]}>
        <LinearGradient
          testID={notificationTestId}
          locations={[0, 1]}
          colors={props.messageTypeInfo ? ['#0586CE', '#056EAA', '#045586'] : ['rgb(207,68,55)', 'rgb(122,40,40)']}
          style={[alertPrompt.alertPermission, props.contained && {position: 'relative'}]}
        >
          <Text
            testID={messageTestId}
            style={{
              marginLeft: 15,
              fontSize: 16,
              color: '#fff',
              width: props.showOKButton ? '60%' : '80%'
            }}
          >
            {props.message}
          </Text>

          {/* Show OK and Cancel buttons if callback is provided */}
          {props.showOKButton ? (
            <View style={{
              position: 'absolute',
              right: 10,
              top: 5,
              flexDirection: 'row',
              alignItems: 'center',
              height: '80%'
            }}>
              <TouchableOpacity
                testID='okButton'
                onPress={props.onOKPress}
                style={{
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  paddingHorizontal: 12,
                  paddingVertical: 6,
                  borderRadius: 4,
                  marginRight: 8
                }}
              >
                <Text style={{ color: '#fff', fontSize: 14, fontWeight: 'bold' }}>
                  OK
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                testID='cancelButton'
                onPress={props.closeAlert}
                style={{
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  paddingHorizontal: 8,
                  paddingVertical: 6,
                  borderRadius: 4
                }}
              >
                <Text style={{ color: '#fff', fontSize: 14 }}>
                  Cancel
                </Text>
              </TouchableOpacity>
            </View>
          ) : (
            // Show only close X button for simple alerts (existing behavior)
            <TouchableOpacity
              testID={closeButtonTestId}
              onPress={props.closeAlert}
              style={{
                position: 'absolute',
                right: windowWidth >=900 ? 10 : 0,
                top :windowWidth >=900 ? 1 :"-1%",
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <i
                className="icon-cancel"
                data-testid={cancelIconTestId}
                style={{ fontSize: '22px', color: 'white' }}
              ></i>
            </TouchableOpacity>
          )}
        </LinearGradient>
      </View>
    </>
  );
}
